import {
  Alert,
  AlertTitle,
  Box,
  Button,
  CircularProgress,
  Divider,
  Paper,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuItemMui from "@mui/material/MenuItem";
import timezone from "dayjs/plugin/timezone";
import { useEffect, useState } from "react";
import Header from "../../components/Header";
import { Grid2 } from "@mui/material";
import { Apartment, SaveAlt, TextSnippet } from "@mui/icons-material";
import { tokens } from "../../theme";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import NotificationToaste from "../global/NotificationToaste";
import dayjs, { utc } from "dayjs";
import axios from "axios";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import { setPostPayload, setPutPayload } from "../../services/api";
import AbcDetails from "./AbcDetails";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const Abc = ({ data, selectedTest, loggedUser, setOpenReportDialog }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [authUsers, setAuthUsers] = useState([]);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const [loading, setLoading] = useState(true);
  const [update, setUpdate] = useState(false);
  const [eachTest, setEachTest] = useState({
    serialNo: "AUTO",
    dateOfCast: "",
    dateOfTest: "",
    weight: "",
    concreteMixtureArray: "",
    areaOfCube: "",
    compressiveStrength: "",
  });
  const [chartData, setChartData] = useState({
    sieve50: 50.0,
    sieve3750: 37.5,
    sieve20: 20.0,
    sieve10: 10.0,
    sieve05: 5.0,
    sieve236: 2.36,
    sieve425: Number(0.425).toFixed(3),
    sieve075: Number(0.075).toFixed(3),
    sieve0: 0,

    weight50: 0.0,
    weight3750: 0.0,
    weight20: 0.0,
    weight10: 0.0,
    weight05: 0.0,
    weight236: 0.0,
    weight425: 0.0,
    weight075: 0.0,
    weight0: 0.0,

    retain50: 0.0,
    retain3750: 0.0,
    retain20: 0.0,
    retain10: 0.0,
    retain05: 0.0,
    retain236: 0.0,
    retain425: 0.0,
    retain075: 0.0,
    retain0: 0.0,

    cum50: 0.0,
    cum3750: 0.0,
    cum20: 0.0,
    cum10: 0.0,
    cum05: 0.0,
    cum236: 0.0,
    cum425: 0.0,
    cum075: 0.0,
    cum0: 0.0,

    passing50: 0.0,
    passing3750: 0.0,
    passing20: 0.0,
    passing10: 0.0,
    passing05: 0.0,
    passing236: 0.0,
    passing425: 0.0,
    passing075: 0.0,
    passing0: 0.0,

    spec50: "100.00%",
    spec3750: "95 - 100%",
    spec20: "60 - 80%",
    spec10: "40 - 60%",
    spec05: "25 - 40%",
    spec236: "15 - 30%",
    spec425: "7 - 19%",
    spec075: "5 - 12%",
    spec0: "",

    spec50min: 100,
    spec3750min: 95,
    spec20min: 60,
    spec10min: 40,
    spec05min: 25,
    spec236min: 15,
    spec425min: 7,
    spec075min: 5,
    spec0min: 0,

    spec50max: 100,
    spec3750max: 100,
    spec20max: 80,
    spec10max: 60,
    spec05max: 40,
    spec236max: 30,
    spec425max: 19,
    spec075max: 12,
    spec0max: 0,

    spec50pass: false,
    spec3750pass: false,
    spec20pass: false,
    spec10pass: false,
    spec05pass: false,
    spec236pass: false,
    spec425pass: false,
    spec075pass: false,
    spec0pass: false,
    totalValueOfWeight: 0.0,
  });
  const calculationOfChart = () => {
    const totalValueOfWeight =
      Number(chartData.weight50) +
      Number(chartData.weight3750) +
      Number(chartData.weight20) +
      Number(chartData.weight10) +
      Number(chartData.weight05) +
      Number(chartData.weight236) +
      Number(chartData.weight425) +
      Number(chartData.weight075) +
      Number(chartData.weight0);

    console.log("total ", totalValueOfWeight);

    setChartData((pre) => ({
      ...pre,
      totalValueOfWeight,
      retain50: (pre.weight50 / totalValueOfWeight) * 100,
      retain3750: (pre.weight3750 / totalValueOfWeight) * 100,
      retain20: (pre.weight20 / totalValueOfWeight) * 100,
      retain10: (pre.weight10 / totalValueOfWeight) * 100,
      retain05: (pre.weight05 / totalValueOfWeight) * 100,
      retain236: (pre.weight236 / totalValueOfWeight) * 100,
      retain425: (pre.weight425 / totalValueOfWeight) * 100,
      retain075: (pre.weight075 / totalValueOfWeight) * 100,
      retain0: (pre.weight0 / totalValueOfWeight) * 100,
    }));

    setChartData((pre) => ({
      ...pre,
      cum50: Number(pre.retain50),
      cum3750: (Number(pre.retain50) + Number(pre.retain3750)) / 100,
      cum20:
        (Number(pre.retain50) + Number(pre.retain3750) + Number(pre.retain20)) /
        100,
      cum10:
        (Number(pre.retain50) +
          Number(pre.retain3750) +
          Number(pre.retain20) +
          Number(pre.retain10)) /
        100,
      cum05:
        (Number(pre.retain50) +
          Number(pre.retain3750) +
          Number(pre.retain20) +
          Number(pre.retain10) +
          Number(pre.retain05)) /
        100,
      cum236:
        (Number(pre.retain50) +
          Number(pre.retain3750) +
          Number(pre.retain20) +
          Number(pre.retain10) +
          Number(pre.retain05) +
          Number(pre.retain236)) /
        100,
      cum425:
        (Number(pre.retain50) +
          Number(pre.retain3750) +
          Number(pre.retain20) +
          Number(pre.retain10) +
          Number(pre.retain05) +
          Number(pre.retain236) +
          Number(pre.retain425)) /
        100,
      cum075:
        (Number(pre.retain50) +
          Number(pre.retain3750) +
          Number(pre.retain20) +
          Number(pre.retain10) +
          Number(pre.retain05) +
          Number(pre.retain236) +
          Number(pre.retain425) +
          Number(pre.retain075)) /
        100,
      cum0:
        (Number(pre.retain50) +
          Number(pre.retain3750) +
          Number(pre.retain20) +
          Number(pre.retain10) +
          Number(pre.retain05) +
          Number(pre.retain236) +
          Number(pre.retain425) +
          Number(pre.retain075) +
          Number(pre.retain0)) /
        100,
    }));

    setChartData((pre) => ({
      ...pre,
      passing50: Number(100),
      passing3750: Number(100) - Number(pre.retain3750),
      passing20: Number(100) - Number(pre.retain3750) - Number(pre.retain20),
      passing10:
        Number(100) -
        Number(pre.retain3750) -
        Number(pre.retain20) -
        Number(pre.retain10),
      passing05:
        Number(100) -
        Number(pre.retain3750) -
        Number(pre.retain20) -
        Number(pre.retain10) -
        Number(pre.retain05),
      passing236:
        Number(100) -
        Number(pre.retain3750) -
        Number(pre.retain20) -
        Number(pre.retain10) -
        Number(pre.retain05) -
        Number(pre.retain236),
      passing425:
        Number(100) -
        Number(pre.retain3750) -
        Number(pre.retain20) -
        Number(pre.retain10) -
        Number(pre.retain05) -
        Number(pre.retain236) -
        Number(pre.retain425),
      passing075:
        Number(100) -
        Number(pre.retain3750) -
        Number(pre.retain20) -
        Number(pre.retain10) -
        Number(pre.retain05) -
        Number(pre.retain236) -
        Number(pre.retain425) -
        Number(pre.retain075),
      passing0:
        Number(100) -
        Number(pre.retain3750) -
        Number(pre.retain20) -
        Number(pre.retain10) -
        Number(pre.retain05) -
        Number(pre.retain236) -
        Number(pre.retain425) -
        Number(pre.retain075) -
        Number(pre.retain0),
    }));

    setChartData((pre) => ({
      ...pre,
      passing0: pre.passing0 < 0 ? 0 : pre.passing0,
    }));

    setChartData((pre) => ({
      ...pre,
      spec50pass:
        Number(pre.passing50) >= Number(pre.spec50min) &&
        Number(pre.passing50) <= Number(pre.spec50max)
          ? true
          : false,
      spec3750pass:
        Number(pre.passing3750) >= Number(pre.spec3750min) &&
        Number(pre.passing3750) <= Number(pre.spec3750max)
          ? true
          : false,
      spec20pass:
        Number(pre.passing20) >= Number(pre.spec20min) &&
        Number(pre.passing20) <= Number(pre.spec20max)
          ? true
          : false,
      spec10pass:
        Number(pre.passing10) >= Number(pre.spec10min) &&
        Number(pre.passing10) <= Number(pre.spec10max)
          ? true
          : false,
      spec05pass:
        Number(pre.passing05) >= Number(pre.spec05min) &&
        Number(pre.passing05) <= Number(pre.spec05max)
          ? true
          : false,
      spec236pass:
        Number(pre.passing236) >= Number(pre.spec236min) &&
        Number(pre.passing236) <= Number(pre.spec236max)
          ? true
          : false,
      spec425pass:
        Number(pre.passing425) >= Number(pre.spec425min) &&
        Number(pre.passing425) <= Number(pre.spec425max)
          ? true
          : false,
      spec075pass:
        Number(pre.passing075) >= Number(pre.spec075min) &&
        Number(pre.passing075) <= Number(pre.spec075max)
          ? true
          : false,
      spec0pass:
        Number(pre.passing0) >= Number(pre.spec0min) &&
        Number(pre.passing0) <= Number(pre.spec0max)
          ? true
          : false,
    }));

    console.log("total ", chartData);
  };

  const [mainData, setMainData] = useState({
    date: dayjs(new Date()).format("YYYY-MM-DD"),
    institute: data.institute,
    reference: "",
    sampleLocation: "",
    cement: "",
    grade: "",
    concreteMixture: "",
    areaOfCube: "5000",
    dateOfCast: dayjs(new Date()).format("YYYY-MM-DD"),
    dateOfTest: dayjs(new Date()).format("YYYY-MM-DD"),
    testDays: "",
    labTestsDataFromSubs: [],
    specialNote:
      "The test results reported herein relate to the specimens submitted to material testing laboratory & we do not certify the quality of a product / site in general.",
    remarks: "",
    reportType: "GRAVEL",
    sampleTakenBy: "",
    testedBy: { id: "" },
    reportedBy: loggedUser,
    authorizedBy: null,
    labRequest: data,
    barcode: "",
    labRequestTests: selectedTest,
    referenceReportNumber: "",
    rejectReason: "",
  });

  const concreteMixtureArray = [{ id: 1, label: "A.B.C", value: "A.B.C" }];

  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    loadBasicData();
    // setTimeout(() => {
    //   calculationOfChart();
    // }, 5000);
    return () => loadBasicData();
  }, []);

  const loadBasicData = async () => {
    // console.log("selectedid ", selectedTest.id);
    setLoading(true);

    await axios
      .get(DATA_SAVE_URL + "/api/v1/dataForm/reportData/" + data.id, {
        params: {
          testId: selectedTest.id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(function (response) {
        // console.log("tada", response.data);
        if (response.data.labTestFormData !== null) {
          setUpdate(true);
          setMainData(response.data.labTestFormData);
          //   console.log("asss", response.data);
          const chartTableData =
            response.data.labTestFormData.labTestsDataFromSubs;
          //   console.log("data ,", chartTableData);

          //   console.log("read data", mainData);

          setChartData((pre) => ({
            ...pre,

            weight50: chartTableData[0]?.weightRetained.toFixed(3),
            retain50: chartTableData[0]?.retained,
            cum50: chartTableData[0]?.cum,
            passing50: chartTableData[0]?.passing,

            weight3750: chartTableData[1]?.weightRetained.toFixed(3),
            retain3750: chartTableData[1]?.retained,
            cum3750: chartTableData[1]?.cum,
            passing3750: chartTableData[1]?.passing,

            weight20: chartTableData[2]?.weightRetained,
            retain20: chartTableData[2]?.retained,
            cum20: chartTableData[2]?.cum,
            passing20: chartTableData[2]?.passing,

            weight10: chartTableData[3]?.weightRetained,
            retain10: chartTableData[3]?.retained,
            cum10: chartTableData[3]?.cum,
            passing10: chartTableData[3]?.passing,

            weight05: chartTableData[4]?.weightRetained.toFixed(3),
            retain05: chartTableData[4]?.retained,
            cum05: chartTableData[4]?.cum,
            passing05: chartTableData[4]?.passing,

            weight236: chartTableData[5]?.weightRetained.toFixed(3),
            retain236: chartTableData[5]?.retained,
            cum236: chartTableData[5]?.cum,
            passing236: chartTableData[5]?.passing,

            weight425: chartTableData[6]?.weightRetained.toFixed(3),
            retain425: chartTableData[6]?.retained,
            cum425: chartTableData[6]?.cum,
            passing425: chartTableData[6]?.passing,

            weight075: chartTableData[7]?.weightRetained.toFixed(3),
            retain075: chartTableData[7]?.retained,
            cum075: chartTableData[7]?.cum,
            passing075: chartTableData[7]?.passing,

            weight0: chartTableData[8]?.weightRetained.toFixed(3),
            retain0: chartTableData[8]?.retained,
            cum0: chartTableData[8]?.cum,
            passing0: chartTableData[8]?.passing,

            totalValueOfWeight:
              Number(chartTableData[0]?.weightRetained) +
              Number(chartTableData[1]?.weightRetained) +
              Number(chartTableData[2]?.weightRetained) +
              Number(chartTableData[3]?.weightRetained) +
              Number(chartTableData[4]?.weightRetained) +
              Number(chartTableData[5]?.weightRetained) +
              Number(chartTableData[6]?.weightRetained) +
              Number(chartTableData[7]?.weightRetained) +
              Number(chartTableData[8]?.weightRetained),

            spec50pass:
              Number(chartTableData[0]?.passing) >= Number(pre.spec50min) &&
              Number(chartTableData[0]?.passing) <= Number(pre.spec50max)
                ? true
                : false,
            spec3750pass:
              Number(chartTableData[1]?.passing) >= Number(pre.spec3750min) &&
              Number(chartTableData[1]?.passing) <= Number(pre.spec3750max)
                ? true
                : false,
            spec20pass:
              Number(chartTableData[2]?.passing) >= Number(pre.spec20min) &&
              Number(chartTableData[2]?.passing) <= Number(pre.spec20max)
                ? true
                : false,
            spec10pass:
              Number(chartTableData[3]?.passing) >= Number(pre.spec10min) &&
              Number(chartTableData[3]?.passing) <= Number(pre.spec10max)
                ? true
                : false,
            spec05pass:
              Number(chartTableData[4]?.passing) >= Number(pre.spec05min) &&
              Number(chartTableData[4]?.passing) <= Number(pre.spec05max)
                ? true
                : false,
            spec236pass:
              Number(chartTableData[5]?.passing) >= Number(pre.spec236min) &&
              Number(chartTableData[5]?.passing) <= Number(pre.spec236max)
                ? true
                : false,
            spec425pass:
              Number(chartTableData[6]?.passing) >= Number(pre.spec425min) &&
              Number(chartTableData[6]?.passing) <= Number(pre.spec425max)
                ? true
                : false,
            spec075pass:
              Number(chartTableData[7]?.passing) >= Number(pre.spec075min) &&
              Number(chartTableData[7]?.passing) <= Number(pre.spec075max)
                ? true
                : false,
            spec0pass:
              Number(chartTableData[8]?.passing) >= Number(pre.spec0min) &&
              Number(chartTableData[8]?.passing) <= Number(pre.spec0max)
                ? true
                : false,
          }));
        } else {
          addCubesToTable();
        }

        setAuthUsers(response.data.authUsers);
      })
      .catch(function (error) {
        console.log(error);
        setMessage(error);
        setMessageType("error");
        setOpen(true);
      });
    setLoading(false);
  };

  const addCubesToTable = () => {
    console.log("data qty " + selectedTest.quantity);
    const newItems = Array.from({ length: selectedTest.quantity }, (_, i) => ({
      serialNo: selectedTest.startingSerialNo + i,
      dateOfCast: dayjs(mainData.dateOfCast).format("YYYY-MM-DD"),
      dateOfTest: dayjs(mainData.dateOfTest).format("YYYY-MM-DD"),
      areaOfCube: mainData.areaOfCube,
      weight: "",
      compressiveStrength: "",
      concreteMixture: mainData.concreteMixture,
    }));
    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: newItems,
    }));
  };

  const addTestHandle = () => {
    // console.log("added test data ", eachTest);

    const updatedTest = {
      ...eachTest, // or pre if it's based on previous state
      dateOfCast: dayjs(mainData.dateOfCast).format("YYYY-MM-DD"),
      dateOfTest: dayjs(mainData.dateOfTest).format("YYYY-MM-DD"),
      areaOfCube: "22500",
      concreteMixture: mainData.concreteMixture,
    };

    setMainData((pre) => ({
      ...pre,
      labTestsDataFromSubs: [...pre.labTestsDataFromSubs, updatedTest],
    }));
  };

  const rearrangeChartArray = () => {
    const sieveArray = [];

    sieveArray.push(
      {
        sieveSize: Number(chartData.sieve50).toFixed(3),
        weightRetained: Number(chartData.weight50).toFixed(3),
        retained: Number(chartData.retain50).toFixed(3),
        cum: Number(chartData.cum50).toFixed(3),
        passing: Number(chartData.passing50).toFixed(3),
        color: chartData.spec50,
        description: chartData.spec50pass ? "SATISFACTORY" : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve3750).toFixed(3),
        weightRetained: Number(chartData.weight3750).toFixed(3),
        retained: Number(chartData.retain3750).toFixed(3),
        cum: Number(chartData.cum3750).toFixed(3),
        passing: Number(chartData.passing3750).toFixed(3),
        color: chartData.spec3750,
        description: chartData.spec3750pass
          ? "SATISFACTORY"
          : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve20).toFixed(3),
        weightRetained: Number(chartData.weight20).toFixed(3),
        retained: Number(chartData.retain20).toFixed(3),
        cum: Number(chartData.cum20).toFixed(3),
        passing: Number(chartData.passing20).toFixed(3),
        color: chartData.spec20,
        description: chartData.spec20pass ? "SATISFACTORY" : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve10).toFixed(3),
        weightRetained: Number(chartData.weight10).toFixed(3),
        retained: Number(chartData.retain10).toFixed(3),
        cum: Number(chartData.cum10).toFixed(3),
        passing: Number(chartData.passing10).toFixed(3),
        color: chartData.spec10,
        description: chartData.spec10pass ? "SATISFACTORY" : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve05).toFixed(3),
        weightRetained: Number(chartData.weight05).toFixed(3),
        retained: Number(chartData.retain05).toFixed(3),
        cum: Number(chartData.cum05).toFixed(3),
        passing: Number(chartData.passing05).toFixed(3),
        color: chartData.spec05,
        description: chartData.spec05pass ? "SATISFACTORY" : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve236).toFixed(3),
        weightRetained: Number(chartData.weight236).toFixed(3),
        retained: Number(chartData.retain236).toFixed(3),
        cum: Number(chartData.cum236).toFixed(3),
        passing: Number(chartData.passing236).toFixed(3),
        color: chartData.spec236,
        description: chartData.spec236pass
          ? "SATISFACTORY"
          : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve425).toFixed(3),
        weightRetained: Number(chartData.weight425).toFixed(3),
        retained: Number(chartData.retain425).toFixed(3),
        cum: Number(chartData.cum425).toFixed(3),
        passing: Number(chartData.passing425).toFixed(3),
        color: chartData.spec425,
        description: chartData.spec425pass
          ? "SATISFACTORY"
          : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve075).toFixed(3),
        weightRetained: Number(chartData.weight075).toFixed(3),
        retained: Number(chartData.retain075).toFixed(3),
        cum: Number(chartData.cum075).toFixed(3),
        passing: Number(chartData.passing075).toFixed(3),
        color: chartData.spec075,
        description: chartData.spec075pass
          ? "SATISFACTORY"
          : "NOT-SATISFACTORY",
      },
      {
        sieveSize: Number(chartData.sieve0).toFixed(3),
        weightRetained: Number(chartData.weight0).toFixed(3),
        retained: Number(chartData.retain0).toFixed(3),
        cum: Number(chartData.cum0).toFixed(3),
        passing: Number(chartData.passing0).toFixed(3),
        color: chartData.spec0,
        description: chartData.spec0pass ? "SATISFACTORY" : "NOT-SATISFACTORY",
      },
    );
    return sieveArray;
  };

  const handleSaveData = async () => {
    if (mainData.testedBy.id === "") {
      setMessage("Select tested by user..!");
      setMessageType("warning");
      setOpen(true);
      return;
    }

    if (!update) {
      setLoading(true);

      //Add sieve data details to main objec array

      const sendObject = {
        date: mainData.date,
        institute: { id: mainData.institute.id },
        reference: mainData.reference,
        sampleLocation: mainData.sampleLocation,
        cement: mainData.cement,
        grade: mainData.grade,
        concreteMixture: mainData.concreteMixture,
        areaOfCube: mainData.areaOfCube,
        dateOfCast: mainData.dateOfCast,
        dateOfTest: mainData.dateOfTest,
        testDays: mainData.testDays,
        labTestsDataFromSubs: rearrangeChartArray(),
        specialNote: mainData.specialNote,
        remarks: mainData.remarks,
        reportType: "GRAVEL-ABC",
        sampleTakenBy: mainData.sampleTakenBy,
        testedBy: { id: mainData.testedBy.id },
        reportedBy: { id: mainData.reportedBy.id },
        authorizedBy: null,
        labRequest: { id: mainData.labRequest.id },
        barcode: "",
        labRequestTests: { id: mainData.labRequestTests.id },
        referenceReportNumber: mainData.referenceReportNumber,
      };
      console.log("main data save sendObject ", sendObject);
      await setPostPayload
        .setPayloadData("/dataForm/saveReport", sendObject)

        .then(function (response) {
          console.log(response);
          setMessage("Data saved successfully..!");
          setMessageType("success");
          setOpen(true);
          // handleClose();
          // resetMainData();
          // reloadTableData();
          setLoading(false);
          setOpenReportDialog(false);
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
    } else {
      setLoading(true);
      // console.log("main data ", mainData);
      setMainData((pre) => ({
        ...pre,
        id: mainData.id,
      }));

      console.log("***asss*********", mainData);

      const sendObject = {
        id: mainData.id,
        date: mainData.date,
        institute: { id: mainData.institute.id },
        reference: mainData.reference,
        sampleLocation: mainData.sampleLocation,
        cement: mainData.cement,
        grade: mainData.grade,
        concreteMixture: mainData.concreteMixture,
        areaOfCube: mainData.areaOfCube,
        dateOfCast: mainData.dateOfCast,
        dateOfTest: mainData.dateOfTest,
        testDays: mainData.testDays,
        labTestsDataFromSubs: rearrangeChartArray(),
        specialNote: mainData.specialNote,
        remarks: mainData.remarks,
        reportType: "GRAVEL-ABC",
        sampleTakenBy: mainData.sampleTakenBy,
        testedBy: { id: mainData.testedBy.id },
        reportedBy: { id: mainData.reportedBy.id },
        authorizedBy: null,
        labRequest: { id: mainData.labRequest.id },
        barcode: mainData.barcode,
        labRequestTests: { id: mainData.labRequestTests.id },
        referenceReportNumber: mainData.referenceReportNumber,
      };

      console.log("************", sendObject);

      await setPutPayload
        .setPayloadData("/dataForm/updateReport", sendObject)
        .then(function (response) {
          // console.log(response);
          setMessage("Data saved successfully..!");
          setMessageType("success");
          setOpen(true);
          // resetMainData();
          // reloadTableData();
          setLoading(false);
          setOpenReportDialog(false);
        })
        .catch(function (error) {
          console.log(error);
          setMessage(error);
          setMessageType("error");
          setOpen(true);
          setLoading(false);
        });
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 0 0 0",
        margin: "0 0 0 0",
      }}
    >
      {mainData.rejectReason === null || mainData.rejectReason === "" ? (
        ""
      ) : (
        <Stack sx={{ width: "100%", marginBottom: "5px" }}>
          <Alert severity="error" width="100%">
            <AlertTitle>This report is rejected.</AlertTitle>
            Reason : {mainData?.rejectReason}
          </Alert>
        </Stack>
      )}

      <Paper
        sx={{
          padding: "10px",
          borderRadius: "8px",
          marginBottom: "20px",
        }}
        elevation={3}
      >
        <Header title="SIEVE ANALYSIS TEST REPORT." subtitle="GENERAL DATA" />
        <Box>
          <Grid2 container spacing={1}>
            <Grid2 size={8}>
              <Paper elevation={2} sx={{ padding: "10px" }}>
                <Grid2 container spacing={2}>
                  <Grid2 size={3}>
                    <Box display="flex" alignItems="center" columnGap="10px">
                      <TextSnippet />
                      <Typography variant="h5">PROJECT</Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={9}>
                    <Typography variant="h5" component="h2">
                      {data.project}
                    </Typography>
                  </Grid2>
                  <Grid2 size={3}>
                    <Box display="flex" alignItems="center" columnGap="10px">
                      <Apartment />
                      <Typography variant="h5" component="h2">
                        INSTITUTE NAME
                      </Typography>
                    </Box>
                  </Grid2>
                  <Grid2 size={9}>
                    <Typography variant="h5" component="h2">
                      {data.institute.instituteName}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Reference"
                      value={mainData.reference}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          reference: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                  <Grid2 size={12} justifyContent="center">
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Sample Locations"
                      value={mainData.sampleLocation}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          sampleLocation: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                  <Grid2 size={12} justifyContent="center">
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      type="text"
                      label="Report Reference Number"
                      value={mainData.referenceReportNumber}
                      onChange={(e) =>
                        setMainData((pre) => ({
                          ...pre,
                          referenceReportNumber: e.target.value,
                        }))
                      }
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Grid2>
                </Grid2>
              </Paper>
            </Grid2>
            <Grid2 size={4}>
              <Paper elevation={2} sx={{ padding: "10px", height: "100%" }}>
                <Grid2 container>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">REPORT NUMBER</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography color={colors.redAccent[500]} variant="h5">
                      {update
                        ? "QC/" +
                          mainData.reportType +
                          "/" +
                          mainData.labRequest.year +
                          "/" +
                          String(mainData.id).padStart(4, "0")
                        : "AUTO"}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">JOB NO</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography color={colors.redAccent[500]} variant="h5">
                      {data.year + "/" + String(data.id).padStart(4, "0")}
                    </Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center">
                    <Typography variant="h5">REPORT DATE</Typography>
                  </Grid2>
                  <Grid2 size={12} textAlign="center" justifyItems="center">
                    <Box sx={{ width: "200px" }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={["DatePicker"]}
                          sx={{ paddingTop: "8px" }}
                        >
                          <DatePicker
                            label="Date of report"
                            size="small"
                            format="YYYY-MM-DD"
                            timezone="Asia/Colombo"
                            value={
                              mainData.date
                                ? dayjs(mainData.date).tz("Asia/Colombo", true)
                                : dayjs(new Date()).tz("Asia/Colombo", true)
                            }
                            onChange={(newValue) => {
                              const colomboTime = newValue?.tz(
                                "Asia/Colombo",
                                true,
                              );
                              setMainData((pre) => ({
                                ...pre,
                                date: dayjs(colomboTime).format("YYYY-MM-DD"),
                              }));
                            }}
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Box>
                  </Grid2>
                </Grid2>
              </Paper>
            </Grid2>
          </Grid2>
        </Box>
      </Paper>
      <Paper
        sx={{ borderRadius: "8px", padding: "10px", width: "100%" }}
        elevation={3}
      >
        <Header
          title="ABC  (TEST METHOD - BS 882 1992)"
          subtitle="ENTER TESTING DATA"
        />
        <Divider sx={{ margin: "10px 0px 10px 0" }} />
        <AbcDetails
          addTestHandle={addTestHandle}
          eachTest={eachTest}
          mainData={mainData}
          setMainData={setMainData}
          isNonMobile={isNonMobile}
          concreteMixtureArray={concreteMixtureArray}
          chartData={chartData}
          setChartData={setChartData}
          calculationOfChart={calculationOfChart}
        />
      </Paper>
      {loading ? (
        <CircularProgress
          sx={{
            color: colors.greenAccent[500],
            position: "absolute",
            zIndex: 10,
          }}
        />
      ) : (
        ""
      )}
      <Paper
        sx={{
          width: "100%",
          padding: "10px",
          borderRadius: "8px",
          marginTop: "20px",
          marginBottom: "20px",
        }}
        elevation={3}
      >
        <Header title="TEST NOTES" subtitle="AUTHORIZE DATA" />
        <Grid2 container spacing={1} marginTop="10px">
          <Grid2 size={12}>
            <TextField
              variant="outlined"
              type="text"
              size="small"
              fullWidth
              label="Special Notes"
              value={mainData.specialNote}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  specialNote: e.target.value,
                }))
              }
            />
          </Grid2>
          <Grid2 size={6}>
            <TextField
              variant="outlined"
              type="text"
              size="small"
              fullWidth
              label="Remarks"
              value={mainData.remarks}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  remarks: e.target.value,
                }))
              }
            />
          </Grid2>
          <Grid2 size={4}>
            <TextField
              variant="outlined"
              type="text"
              size="small"
              fullWidth
              label="Sample taken / supplied by"
              value={mainData.sampleTakenBy}
              onChange={(e) =>
                setMainData((pre) => ({
                  ...pre,
                  sampleTakenBy: e.target.value,
                }))
              }
            />
          </Grid2>
          <Grid2 size={2}>
            <TextField
              select
              label="Tested by"
              fullWidth
              size="small"
              defaultValue=""
              value={mainData.testedBy.id}
              onChange={(e) => {
                e.preventDefault();
                setMainData((pre) => ({
                  ...pre,
                  testedBy: {
                    ...pre.testedBy,
                    id: e.target.value,
                  },
                }));
              }}
            >
              {authUsers.map((data) => (
                <MenuItemMui key={data.id} value={data.id}>
                  {data.firstName + " " + data.lastName}
                </MenuItemMui>
              ))}
            </TextField>
          </Grid2>

          <Grid2 size={12} display="flex" justifyContent="flex-end">
            <Divider sx={{ width: "100%" }} />
          </Grid2>

          <Grid2 size={12} display="flex" justifyContent="flex-end">
            <Button
              type="submit"
              color="secondary"
              loading={loading}
              startIcon={<SaveAlt />}
              variant="contained"
              onClick={handleSaveData}
            >
              Save Data
            </Button>
          </Grid2>
        </Grid2>
      </Paper>
      <NotificationToaste
        handleCloseToaste={handleCloseToaste}
        open={open}
        message={message}
        messageType={messageType}
      />
    </Box>
  );
};

export default Abc;
